import React from "react";

// ASSETS

// STYLES
import {
  BodyRow,
  BodyRowWrapper,
  Bullet,
  DashedLine,
  HourWrapper,
  RowContent,
  Time,
  VerticalLine,
} from "./AgendaRowStyled";

// LIBRARIES

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { AgendaRowProps } from "./AgendaRowModel";

// REDUX

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";

const AgendaRow: React.FC<AgendaRowProps> = ({
  title,
  description,
  color,
  isLast = false,
}) => {
  // PROPERTIES

  // LIBRARY CONSTANTS

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <BodyRowWrapper>
      <Time>
        <Bullet color={color}>
          <DashedLine isLast={isLast} />
        </Bullet>
      </Time>
      <BodyRow>
        <VerticalLine color={color} />
        <RowContent>
          <CustomText type={TextType.H4} text={title} color={color} />
          <CustomText
            type={TextType.P2}
            text={description}
            color={COLORS.RaisinBlack}
          />
        </RowContent>
      </BodyRow>
    </BodyRowWrapper>
  );
};

export default AgendaRow;
